import { type CallWindow } from '@kalos/kalos-rpc';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CallWindowCalendar } from '../modules/CallWindowCalendar/components/CallWindowCalendar';

export const Route = createFileRoute('/appointment-scheduler')({
  component: RouteComponent,
  validateSearch: z.object({
    view: z.enum(['day', 'week', 'month']).default('week'),
  }),
  head(ctx) {
    return {
      meta: [{ title: 'Appointment Scheduler' }],
    };
  },
});

function RouteComponent() {
  const searchParams = Route.useSearch();

  const handleViewDetails = (window: CallWindow, date: string) => {
    console.log('View details for:', window, date);
  };

  const handleAddJob = (window: CallWindow, date: string) => {
    console.log('Add job for:', window, date);
  };

  return (
    <CallWindowCalendar
      initialView={searchParams.view}
      onViewDetails={handleViewDetails}
      onAddJob={handleAddJob}
    />
  );
}
